import React, { useState } from 'react';
import BoxWrapper from '../boxwra';
import ConfirmationDialog from '../../../Sales/TDSReconciliationSale/ConfirmationDailog';
import { Snackbar, Alert } from '@mui/material';

function Fourteen({ handleBack, updateTableData, data }) {
  const [tableData, setTableData] = useState(data);
  const [tableName] = useState(
    "14.Differential tax paid on account of declaration in 10 & 11 above"
  );
  const [saveDailog, setSaveDailogOpen] = useState(false);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [confirmBack, setConfirmBack] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  // const submitHandle = () => {
  //   updateTableData(tableName, tableData);
  //   setUnsavedChanges(false);
  //   setSaveDailogOpen(false);
  //   setSnackbarOpen(true);
  // };


  const submitHandle = () => {
  // In case future rows become calculated (e.g., a total row), 
  // this ensures we send clean, up-to-date data.
  // Currently all rows are manual, so we just send tableData as-is.
  // But we keep the structure consistent with other tables.
  const dataToSubmit = tableData.map((item) => ({
    ...item,
    // Explicitly preserve cleaned values (already stored as strings from input)
    tax_payble: item.tax_payble || '',
    paid_through_itc: item.paid_through_itc || '',
    difference: item.difference || '',
  }));

  updateTableData(tableName, dataToSubmit);

  setUnsavedChanges(false);
  setSaveDailogOpen(false);
  setSnackbarOpen(true);
};
  const handleBackButton = () => {
    if (unsavedChanges) {
      setConfirmBack(true);
    } else {
      handleBack();
    }
  };

  const confirmBackHandle = () => {
    submitHandle();
    handleBack();
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  // Helper functions (unchanged)
  const safeParseFloat = (value) => {
    if (!value || value === '' || value === '-') return 0;
    const stringValue = String(value);
    if (stringValue.endsWith('.')) return 0;
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  };

  const formatRupee = (value, isManualInput = false) => {
    if (isManualInput && (!value || value === 0 || value === '0' || value === '0.00')) {
      return '';
    }
    if (!value && value !== 0) return '';
    const hasDecimal = value.toString().includes('.');
    const decimalPlaces = hasDecimal ? value.toString().split('.')[1]?.length || 0 : 0;
    const formatter = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: hasDecimal && decimalPlaces > 0 ? Math.min(decimalPlaces, 2) : 0,
      maximumFractionDigits: 2,
    });
    return formatter.format(value).replace('INR', '₹');
  };

  const parseRupee = (value) => {
    if (!value) return '';
    let cleaned = value.replace(/[^0-9.-]/g, '');
    const parts = cleaned.split('.');
    if (parts.length > 2) cleaned = parts[0] + '.' + parts.slice(1).join('');
    if (cleaned.startsWith('-')) {
      cleaned = '-' + cleaned.substring(1).replace(/-/g, '');
    } else {
      cleaned = cleaned.replace(/-/g, '');
    }
    return cleaned;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const [itemName, field] = name.split(',');
    const cleanedValue = parseRupee(value);

    setTableData((prev) =>
      prev.map((item) =>
        item.name === itemName ? { ...item, [field]: cleanedValue } : item
      )
    );
    setUnsavedChanges(true);
  };

  const renderTableRows = () => {
    const getRowColor = (index) => {
      const colors = ['#e0e7ff', '#e9d5ff', '#f3e8ff', '#ede9fe', '#ddd6fe'];
      return colors[index % colors.length];
    };

    return tableData.map((item, index) => {
      const isManualInputRow = true;

      return (
        <div
          key={index}
          style={{
            display: 'grid',
            gridTemplateColumns: '60px 1fr 150px 150px 150px', // 5 columns
            gap: '10px',
            alignItems: 'center',
            padding: '8px 10px',
            borderBottom: '1px solid #f1f5f9',
            backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc',
            borderRadius: '6px',
            marginBottom: '2px',
            minHeight: '50px',
          }}
        >
          {/* S.No. */}
          <span
            style={{
              color: '#1e293b',
              fontSize: '13px',
              fontWeight: '600',
              textAlign: 'center',
              padding: '8px 6px',
              backgroundColor: getRowColor(index),
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {index + 1}
          </span>

          {/* Description */}
          <span
            style={{
              color: '#334155',
              fontSize: '13px',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              wordBreak: 'break-word',
              textAlign: 'left',
              display: 'flex',
              alignItems: 'center',
              minHeight: '34px',
            }}
          >
            {item.name}
          </span>

          {/* Payable */}
          <input
            type="text"
            className="blue-color"
            name={`${item.name},tax_payble`}
            value={
              isManualInputRow
                ? item.tax_payble === '' || item.tax_payble === '-' || String(item.tax_payble).endsWith('.')
                  ? item.tax_payble
                  : formatRupee(safeParseFloat(item.tax_payble), true)
                : formatRupee(item.tax_payble) || ''
            }
            onChange={handleInputChange}
            style={{
              color: '#1e293b',
              fontWeight: '500',
              fontSize: '13px',
              textAlign: 'right',
              padding: '8px 12px',
              backgroundColor: '#ecfdf5',
              border: '1px solid #e2e8f0',
              borderRadius: '6px',
              outline: 'none',
              minHeight: '34px',
              width: '100%',
            }}
            onFocus={(e) => {
              if (isManualInputRow) {
                e.target.value = item.tax_payble || '';
                e.target.style.borderColor = '#88d8a3';
                e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
              }
            }}
            onBlur={(e) => {
              if (isManualInputRow) {
                const rawVal = e.target.value;
                const cleanedVal = parseRupee(rawVal);
                const numVal = safeParseFloat(cleanedVal);
                const finalDisplay =
                  cleanedVal === '' || cleanedVal === '-' || String(cleanedVal).endsWith('.')
                    ? cleanedVal
                    : formatRupee(numVal, true);
                e.target.value = finalDisplay;
                setTableData((prev) =>
                  prev.map((it) =>
                    it.name === item.name ? { ...it, tax_payble: cleanedVal } : it
                  )
                );
                e.target.style.borderColor = '#e2e8f0';
                e.target.style.boxShadow = 'none';
              }
            }}
          />

          {/* Paid */}
          <input
            type="text"
            className="blue-color"
            name={`${item.name},paid_through_itc`}
            value={
              isManualInputRow
                ? item.paid_through_itc === '' || item.paid_through_itc === '-' || String(item.paid_through_itc).endsWith('.')
                  ? item.paid_through_itc
                  : formatRupee(safeParseFloat(item.paid_through_itc), true)
                : formatRupee(item.paid_through_itc) || ''
            }
            onChange={handleInputChange}
            style={{
              color: '#1e293b',
              fontWeight: '500',
              fontSize: '13px',
              textAlign: 'right',
              padding: '8px 12px',
              backgroundColor: '#ecfdf5',
              border: '1px solid #e2e8f0',
              borderRadius: '6px',
              outline: 'none',
              minHeight: '34px',
              width: '100%',
            }}
            onFocus={(e) => {
              if (isManualInputRow) {
                e.target.value = item.paid_through_itc || '';
                e.target.style.borderColor = '#88d8a3';
                e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
              }
            }}
            onBlur={(e) => {
              if (isManualInputRow) {
                const rawVal = e.target.value;
                const cleanedVal = parseRupee(rawVal);
                const numVal = safeParseFloat(cleanedVal);
                const finalDisplay =
                  cleanedVal === '' || cleanedVal === '-' || String(cleanedVal).endsWith('.')
                    ? cleanedVal
                    : formatRupee(numVal, true);
                e.target.value = finalDisplay;
                setTableData((prev) =>
                  prev.map((it) =>
                    it.name === item.name ? { ...it, paid_through_itc: cleanedVal } : it
                  )
                );
                e.target.style.borderColor = '#e2e8f0';
                e.target.style.boxShadow = 'none';
              }
            }}
          />

          {/* Difference */}
          <input
            type="text"
            className="blue-color"
            name={`${item.name},difference`}
            value={
              isManualInputRow
                ? item.difference === '' || item.difference === '-' || String(item.difference).endsWith('.')
                  ? item.difference
                  : formatRupee(safeParseFloat(item.difference), true)
                : formatRupee(item.difference) || ''
            }
            onChange={handleInputChange}
            style={{
              color: '#1e293b',
              fontWeight: '500',
              fontSize: '13px',
              textAlign: 'right',
              padding: '8px 12px',
              backgroundColor: '#ecfdf5',
              border: '1px solid #e2e8f0',
              borderRadius: '6px',
              outline: 'none',
              minHeight: '34px',
              width: '100%',
            }}
            onFocus={(e) => {
              if (isManualInputRow) {
                e.target.value = item.difference || '';
                e.target.style.borderColor = '#88d8a3';
                e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
              }
            }}
            onBlur={(e) => {
              if (isManualInputRow) {
                const rawVal = e.target.value;
                const cleanedVal = parseRupee(rawVal);
                const numVal = safeParseFloat(cleanedVal);
                const finalDisplay =
                  cleanedVal === '' || cleanedVal === '-' || String(cleanedVal).endsWith('.')
                    ? cleanedVal
                    : formatRupee(numVal, true);
                e.target.value = finalDisplay;
                setTableData((prev) =>
                  prev.map((it) =>
                    it.name === item.name ? { ...it, difference: cleanedVal } : it
                  )
                );
                e.target.style.borderColor = '#e2e8f0';
                e.target.style.boxShadow = 'none';
              }
            }}
          />
        </div>
      );
    });
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '20px',
          padding: '30px',
          width: '100%',
          boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
        }}
      >
        <BoxWrapper backButtonForZohoEnable={true} backButton={handleBackButton} boxTitle={tableName}>
          <p style={{ marginLeft: '10px' }}>
            <span style={{ fontWeight: 'bold' }}>Note: </span> The fields where the system computed values would be modified by more/less 20% shall be highlighted in <span style={{ color: 'red' }}>Red</span> for reference and attention.
          </p>
          <hr style={{ marginLeft: '10px' }} />
        </BoxWrapper>

        <div style={{ maxHeight: 'calc(100vh - 450px)', overflowY: 'auto', marginTop: '10px' }}>
          {/* Header */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '60px 1fr 150px 150px 150px',
              gap: '10px',
              alignItems: 'center',
              padding: '8px 10px',
              borderBottom: '2px solid #e2e8f0',
              backgroundColor: '#f8fafc',
              borderRadius: '6px',
              marginBottom: '2px',
              minHeight: '50px',
              fontWeight: '600',
              color: '#475569',
              fontSize: '13px',
              position: 'sticky',
              top: '0',
              zIndex: '10',
            }}
          >
            <span style={{ textAlign: 'center', backgroundColor: '#e0e7ff', borderRadius: '6px', padding: '8px 6px' }}>S.No.</span>
            <span style={{ textAlign: 'left', backgroundColor: '#f1f5f9', borderRadius: '6px', padding: '8px 12px' }}>Description</span>
            <span style={{ textAlign: 'right', backgroundColor: '#f1f5f9', borderRadius: '6px', padding: '8px 12px', justifyContent: 'flex-end', display: 'flex' }}>Payable (₹)</span>
            <span style={{ textAlign: 'right', backgroundColor: '#f1f5f9', borderRadius: '6px', padding: '8px 12px', justifyContent: 'flex-end', display: 'flex' }}>Paid (₹)</span>
            <span style={{ textAlign: 'right', backgroundColor: '#f1f5f9', borderRadius: '6px', padding: '8px 12px', justifyContent: 'flex-end', display: 'flex' }}>Difference (₹)</span>
          </div>

          {tableData && tableData.length >= 1 ? renderTableRows() : (
            <div style={{ textAlign: 'center', color: '#64748b', padding: '20px' }}>No Data Found!</div>
          )}
        </div>

        {/* Footer */}
        <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8fafc', borderRadius: '8px', borderTop: '2px solid #e2e8f0' }}>
          <p style={{ margin: '0', fontSize: '14px', color: '#64748b', textAlign: 'center' }}>
            Total Records: {tableData?.length || 0}
          </p>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px', gap: '10px' }}>
          <button
            type="button"
            className="button-primary"
            onClick={() => setSaveDailogOpen(true)}
            style={{
              padding: '10px 20px',
              background: 'linear-gradient(135deg, #ffd3a5 0%, #fd9853 50%, #e8a87c 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(255, 211, 165, 0.3)',
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '0 6px 16px rgba(255, 211, 165, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(255, 211, 165, 0.3)';
            }}
          >
            Save
          </button>
        </div>
      </div>

      {/* Dialogs & Snackbar (unchanged) */}
      <ConfirmationDialog
        open={saveDailog}
        onClose={() => setSaveDailogOpen(false)}
        onConfirm={submitHandle}
        title="Confirm Save"
        text="Do you want to save your changes? This action will update the current data."
      />
      <ConfirmationDialog
        open={confirmBack}
        onConfirm={confirmBackHandle}
        onClose={() => handleBack()}
        title="Unsaved Changes"
        text="You have unsaved changes. Do you want to leave without saving?"
      />
      <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
          Data saved successfully!
        </Alert>
      </Snackbar>
    </div>
  );
}

export default Fourteen;